import styled from 'styled-components';

export const BackButtonWrapper = styled.img` 
  top: 60px;
  left: 60px;
  width: 50px; // Ajuste o tamanho conforme necessário
  height: 50px;
  cursor: pointer;
`;
